import React, { FC } from 'react';
import { TNewsCardProps } from './types/newsCard.types';
import { NewsCardModel } from './models/newsCard.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import useEEActive from '../../../../hooks/useEEActive';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import NewsCardContent from './newsCardContent';
import AnalyticsVisibleEvent from '../../../@shared/analyticsVisibleEvent';
import './styles.scss';

const NewsCard: FC<TNewsCardProps> = (props: TNewsCardProps) => {
  const model = new NewsCardModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const isEE = useEEActive(true);

  return (
    <article className="case-news-card">
      {isEE ? (
        <NewsCardContent
          desktopCardImage={model?.image}
          mobileCardImage={model.mobileImage}
          formatDate={model.date}
          title={model.title}
          subtitle={model.subtitle}
          link={model.link}
          isEE={isEE}
          cardHeadingTitleTag={props?.cardHeadingTitleTag}
        />
      ) : (
        <AnalyticsVisibleEvent event={'home_latest_updates_visible'} title={model.title?.value} className="case-news-card__wrapper">
          <RoutableSitecoreLink field={model.link} target={targetLinkdsk(model?.link, isDesktop)}>
            <NewsCardContent
              desktopCardImage={model?.image}
              mobileCardImage={model.mobileImage}
              formatDate={model.date}
              title={model.title}
              subtitle={model.subtitle}
              link={model.link}
              isEE={isEE}
              cardHeadingTitleTag={props?.cardHeadingTitleTag}
            />
          </RoutableSitecoreLink>
        </AnalyticsVisibleEvent>
      )}
    </article>
  );
};

export default NewsCard;
